(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCompare(el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var range = el.querySelector('[data-range]');
      var before = el.querySelector('[data-before]');
      var line = el.querySelector('[data-line]');
      var dragging = false;
      function set(v) {
        v = Math.max(0, Math.min(100, v));
        range.value = v;
        before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        line.style.left = v + '%';
      }
      function fromEvent(e) {
        var r = el.getBoundingClientRect();
        set(((e.clientX - r.left) / r.width) * 100);
      }
      el.addEventListener('pointerdown', function (e) {
        dragging = true;
        // A finger landing on the photo may be starting a page scroll, so only jump on mouse click;
        // touch moves the divider once the browser confirms a sideways drag (vertical ones cancel).
        if (e.pointerType === 'mouse') fromEvent(e);
      });
      el.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) {
        el.addEventListener(t, function () { dragging = false; });
      });
      range.addEventListener('input', function () { set(Number(range.value)); });
      set(50);
    }
    function initAll() { document.querySelectorAll('[data-compare]').forEach(initCompare); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-coverflow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCoverflow(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      var n = cards.length;
      if (!n) return;
      var active = 0, timer = null, startX = null;
      function layout() {
        var wide = window.innerWidth >= 750;
        var step = wide ? 190 : window.innerWidth * 0.36;
        cards.forEach(function (card, i) {
          var off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var abs = Math.abs(off);
          var scale = 1 - Math.min(abs, 3) * 0.13;
          card.style.transform = 'translateX(' + off * step + 'px) rotateY(' + (off * -18) + 'deg) scale(' + scale + ')';
          card.style.zIndex = String(20 - abs);
          card.style.opacity = abs > 2 ? '0' : '1';
          card.style.filter = abs ? 'brightness(.82)' : 'none';
          card.setAttribute('aria-hidden', abs ? 'true' : 'false');
        });
      }
      function go(d) { active = (active + d + n) % n; layout(); }
      function restart() {
        if (timer) clearInterval(timer);
        if (root.dataset.autoplay === 'true') timer = setInterval(function () { go(1); }, 3500);
      }
      root.querySelector('[data-prev]').addEventListener('click', function () { go(-1); restart(); });
      root.querySelector('[data-next]').addEventListener('click', function () { go(1); restart(); });
      cards.forEach(function (card, i) {
        card.addEventListener('click', function () { if (i !== active) { active = i; layout(); restart(); } });
      });
      var stage = root.querySelector('[data-stage]');
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); restart(); }
        startX = null;
      });
      window.addEventListener('resize', layout);
      layout();
      restart();
    }
    function initAll() { document.querySelectorAll('.pvcf').forEach(initCoverflow); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      if (root.dataset.ready) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      if (!cards.length) return;
      root.dataset.ready = '1';
      var dots = root.querySelectorAll('.pvts__dot');
      var stage = root.querySelector('[data-stage]');
      var n = cards.length, active = 0, startX = null;
      function layout() {
        var maxH = 0;
        cards.forEach(function (card, i) {
          var off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var abs = Math.abs(off);
          card.style.transform = 'translateX(' + off * 92 + '%) scale(' + (abs ? 0.9 : 1) + ')';
          card.style.opacity = abs > 1 ? '0' : abs ? '0.55' : '1';
          card.style.zIndex = String(10 - abs);
          maxH = Math.max(maxH, card.offsetHeight);
        });
        stage.style.height = maxH + 24 + 'px';
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
      }
      function go(d) { active = (active + d + n) % n; layout(); }
      root.querySelector('[data-prev]').addEventListener('click', function () { go(-1); });
      root.querySelector('[data-next]').addEventListener('click', function () { go(1); });
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        startX = null;
      });
      window.addEventListener('resize', layout);
      layout();
    }
    function initAll() { document.querySelectorAll('.pvts').forEach(initReviews); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
